import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../components/ui/dialog";
import { Check, Copy, Loader2 } from "lucide-react";

export default function DraftDialog({ open, draft, loading, onClose }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(draft || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      // ignore
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-3xl"
        data-testid="dispute-draft-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-display font-bold text-xl">
            Dispute draft
          </DialogTitle>
          <DialogDescription className="text-xs text-[#525252]">
            Generated email draft. Review, copy, and paste into your email
            client.
          </DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="flex items-center gap-2 text-sm text-[#525252] py-8">
            <Loader2 className="w-4 h-4 animate-spin" /> Generating draft…
          </div>
        ) : (
          <>
            <pre
              className="bg-[#FAFAFA] border border-[#E5E5E5] rounded-md p-4 text-xs font-mono-tabular whitespace-pre-wrap max-h-[60vh] overflow-y-auto scroll-thin"
              data-testid="draft-text"
            >
              {draft}
            </pre>
            <div className="flex justify-end pt-2">
              <button
                onClick={handleCopy}
                className="inline-flex items-center gap-2 px-4 py-2 bg-[#0A0A0A] text-white text-sm font-medium rounded-md hover:bg-[#171717]"
                data-testid="copy-draft-btn"
              >
                {copied ? (
                  <>
                    <Check className="w-4 h-4" /> Copied
                  </>
                ) : (
                  <>
                    <Copy className="w-4 h-4" /> Copy to clipboard
                  </>
                )}
              </button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
